export enum HealthOrganizationTypesEnum {
    Practice = 1,
    Clinic = 2,
    HealthcareFacilities = 3,
    Employers = 4,
    BrokerAgent = 5,
    SocialServices = 6,
    NonProfit510C = 7
}
